import { css } from 'styled-components';
import { MoneyEditButtonProps } from './models';

export const MoneyEditButton = css<MoneyEditButtonProps>(
  ({ theme }) =>
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      cursor: pointer;

      > .content {
        margin-right: 5px;
        font-weight: 700;
        font-size: 21px;
        color: ${theme.colors.primaryBright};
        text-decoration-line: underline;
      }
    `
);
